(function () {
  function formatMoney(cents) {
    // If Shopify.formatMoney exists, use it; otherwise fallback to $X.XX
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents);
    }
    return `$${(cents / 100).toFixed(2)}`;
  }

  function getSelectedOptions(root) {
    const checked = root.querySelectorAll('input.var-input[type="radio"]:checked');
    return Array.from(checked).map((el) => el.value);
  }

  function findVariantByOptions(variants, selectedOptions) {
    return variants.find((v) => {
      if (!Array.isArray(v.options)) return false;
      for (let i = 0; i < selectedOptions.length; i++) {
        if (v.options[i] !== selectedOptions[i]) return false;
      }
      return true;
    });
  }

  document.addEventListener("change", function (e) {
    const root = e.target.closest("prod-vars.product-variants");
    if (!root) return;
    if (!e.target.matches('input.var-input[type="radio"]')) return;

    const jsonEl = root.querySelector("[data-variants-json]");
    if (!jsonEl) return;

    let variants;
    try {
      variants = JSON.parse(jsonEl.textContent || "[]");
    } catch {
      return;
    }

    const selectedOptions = getSelectedOptions(root);
    const match = findVariantByOptions(variants, selectedOptions);
    if (!match) return;

    // Update hidden variant id[] for ATC
    const idInput = root.querySelector('input[data-var-key="id"]');
    if (idInput) idInput.value = match.id;

    // Update your new price line
    const priceEl = root.querySelector("[data-variant-price]");
    if (priceEl) priceEl.textContent = formatMoney(match.price);
  });
})();
